@if (form) {
  <div [formGroup]="form" class="modalForm">
    <div class="flex flex-column gap-2 mb-3">
      <label class="font-semibold w-full" for="role"
        >{{ "admin.tenant_administration.available_cores" | translate }}*</label
      >
      <p-select
        formControlName="coreId"
        [options]="coreOptions()"
        optionLabel="serialNumber"
        optionValue="id"
        appendTo="body"
        class="w-full"
        [filter]="true"
        filterBy="serialNumber"
        [emptyMessage]="translate.instant('admin.tenant_administration.no_available_cores')"
      />
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button buttonText="common.save" [disabled]="!form.valid" (click)="save()"></app-button>
    </div>
  </div>
}
